var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentUnit)?_c('ProductForm',{attrs:{"data":_vm.data,"mutation":_vm.CREATE_PRODUCT,"parent-popup":_vm.parentPopup},on:{"mutation-done":function (cache, data) { return _vm.$emit('product-created', data); }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }